import { JetView } from 'webix-jet';

/**
 * Class representing the details view of a bonus report.
 * @extends JetView
 */
export default class detailsBonusReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information layout
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                // Input fields for ID, Type, Date, and Amount
                                {
                                    view: 'text',
                                    name: 'Id',
                                    label: _("<span class='icon-id'></span> ID"),
                                    labelPosition: 'top',
                                    placeholder: _('Id'),
                                    invalidMessage: _('A ID is required'),
                                    disabled: true,
                                },
                                {
                                    view: 'text',
                                    name: 'Type',
                                    label: _('Tipo'),
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'),
                                    disabled: true,
                                },
                                {
                                    view: 'text',
                                    name: 'Date',
                                    label: _('Fecha'),
                                    labelPosition: 'top',
                                    placeholder: _('Fecha'),
                                    disabled: true,
                                },
                                {
                                    view: 'text',
                                    name: 'Amount',
                                    label: _('Monto'),
                                    labelPosition: 'top',
                                    placeholder: _('Monto'),
                                    disabled: true,
                                    id: 'Monto', // ID for Amount field
                                },
                            ],
                        },
                        {
                            rows: [
                                {},
                                {},
                                {
                                    id: 'buttonArrow', // ID for the button
                                    hidden: true, // Initially hidden
                                    width: 150,
                                    css: 'divButtonArrow',
                                    cols: [
                                        {},
                                        {
                                            view: 'button',
                                            value: "<span class='icon-arrow-up'></span>",
                                            css: 'buttonArrow',
                                            align: 'right',
                                            bottom: 20,
                                            right: 35,
                                            width: 50,
                                            height: 60,
                                            on: {
                                                onItemClick: function () {
                                                    $$('a5').scrollTo(100, 0); // Scroll action on button click
                                                },
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Left main layout configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Upper section layout for larger screens
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 20 }],
        };

        // Upper section layout for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'formDetails', // ID for the form
            rows: [screen !== 'small' ? upper_section : upper_section_narrow],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        // Event listener for selecting a bonus transaction detail
        this.on(this.app, 'bonusTransDetail:select', (person) => {
            form.setValues(person); // Set form values based on selected person
            this.$$('Monto').setValue(webix.i18n.priceFormat(person.Amount)); // Format and set Amount value
        });

        // Show buttonArrow if screen width is less than 500
        webix.ready(function () {
            if (screen.width < 500) {
                $$('buttonArrow').show();
            }
        });
    }
}

// FILE DOCUMENTED
